/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduleLogWithMonthDto } from '../../models/schedule-log-with-month-dto';

export interface ScheduleLogControllerFindByTicketIdWithMonth$Params {
  ticketId: string;
}

export function scheduleLogControllerFindByTicketIdWithMonth(http: HttpClient, rootUrl: string, params: ScheduleLogControllerFindByTicketIdWithMonth$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ScheduleLogWithMonthDto>>> {
  const rb = new RequestBuilder(rootUrl, scheduleLogControllerFindByTicketIdWithMonth.PATH, 'get');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ScheduleLogWithMonthDto>>;
    })
  );
}

scheduleLogControllerFindByTicketIdWithMonth.PATH = '/api/schedule-log/month';
